'use client'

import Image from 'next/image'
import React, { useEffect, useRef, useState } from 'react'

type SectionId = 'introduction' | 'data-collection' | 'use-of-data'

const sections: { id: SectionId; label: string; Icon: React.FC<{ className?: string }> }[] = [
  {
    id: 'introduction',
    label: 'INTRODUCTION',
    Icon: ({ className }) => (
      <svg
        width="27"
        height="27"
        viewBox="0 0 27 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden
      >
        <path
          d="M16.4306 2.19141H6.57173C5.99067 2.19141 5.43342 2.42223 5.02255 2.8331C4.61168 3.24396 4.38086 3.80122 4.38086 4.38228V21.9092C4.38086 22.4903 4.61168 23.0475 5.02255 23.4584C5.43342 23.8693 5.99067 24.1001 6.57173 24.1001H19.7169C20.298 24.1001 20.8553 23.8693 21.2661 23.4584C21.677 23.0475 21.9078 22.4903 21.9078 21.9092V7.66858L16.4306 2.19141Z"
          strokeWidth="2.19087"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.3359 2.19141V6.57314C15.3359 7.1542 15.5668 7.71146 15.9776 8.12232C16.3885 8.53319 16.9458 8.76401 17.5268 8.76401H21.9085"
          strokeWidth="2.19087"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.9526 9.85938H8.76172"
          strokeWidth="2.19087"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.5252 14.2402H8.76172"
          strokeWidth="2.19087"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.5252 18.623H8.76172"
          strokeWidth="2.19087"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    id: 'data-collection',
    label: 'DATA COLLECTION',
    Icon: ({ className }) => (
      <svg
        width="23"
        height="23"
        viewBox="0 0 23 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden
      >
        <path
          d="M11.1875 7.45996C15.8215 7.45996 19.5781 6.20776 19.5781 4.66309C19.5781 3.11841 15.8215 1.86621 11.1875 1.86621C6.55349 1.86621 2.79688 3.11841 2.79688 4.66309C2.79688 6.20776 6.55349 7.45996 11.1875 7.45996Z"
          strokeWidth="1.86458"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.79688 4.66309V17.7152C2.79688 18.4569 3.68088 19.1683 5.25443 19.6929C6.82798 20.2174 8.96217 20.512 11.1875 20.512C13.4128 20.512 15.547 20.2174 17.1206 19.6929C18.6941 19.1683 19.5781 18.4569 19.5781 17.7152V4.66309"
          strokeWidth="1.86458"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.79688 11.1875C2.79688 11.9293 3.68088 12.6407 5.25443 13.1652C6.82798 13.6897 8.96217 13.9844 11.1875 13.9844C13.4128 13.9844 15.547 13.6897 17.1206 13.1652C18.6941 12.6407 19.5781 11.9293 19.5781 11.1875"
          strokeWidth="1.86458"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    id: 'use-of-data',
    label: 'USE OF DATA',
    Icon: ({ className }) => (
      <svg
        width="23"
        height="23"
        viewBox="0 0 23 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden
      >
        <path
          d="M11.3914 1.86426H10.9812C10.4867 1.86426 10.0124 2.0607 9.66275 2.41038C9.31307 2.76006 9.11662 3.23432 9.11662 3.72884V3.89665C9.11629 4.22363 9.02997 4.54477 8.86634 4.82786C8.7027 5.11095 8.4675 5.34603 8.18433 5.50952L7.78345 5.74259C7.49999 5.90624 7.17846 5.9924 6.85115 5.9924C6.52385 5.9924 6.20232 5.90624 5.91886 5.74259L5.77902 5.66801C5.35116 5.4212 4.84285 5.35424 4.36567 5.48184C3.88849 5.60943 3.48143 5.92116 3.23386 6.34858L3.02876 6.70285C2.78195 7.13071 2.71499 7.63902 2.84259 8.1162C2.97019 8.59338 3.28191 9.00044 3.70933 9.24801L3.84918 9.34124C4.13099 9.50393 4.36531 9.73754 4.52886 10.0189C4.69242 10.3002 4.7795 10.6194 4.78147 10.9448V11.4202C4.78277 11.7488 4.69724 12.0719 4.53352 12.3567C4.3698 12.6416 4.13372 12.8782 3.84918 13.0424L3.70933 13.1263C3.28191 13.3739 2.97019 13.781 2.84259 14.2581C2.71499 14.7353 2.78195 15.2436 3.02876 15.6715L3.23386 16.0258C3.48143 16.4532 3.88849 16.7649 4.36567 16.8925C4.84285 17.0201 5.35116 16.9532 5.77902 16.7063L5.91886 16.6318C6.20232 16.4681 6.52385 16.3819 6.85115 16.3819C7.17846 16.3819 7.49999 16.4681 7.78345 16.6318L8.18433 16.8648C8.4675 17.0283 8.7027 17.2634 8.86634 17.5465C9.02997 17.8296 9.11629 18.1507 9.11662 18.4777V18.6455C9.11662 19.14 9.31307 19.6143 9.66275 19.964C10.0124 20.3136 10.4867 20.5101 10.9812 20.5101H11.3914C11.8859 20.5101 12.3602 20.3136 12.7099 19.964C13.0596 19.6143 13.256 19.14 13.256 18.6455V18.4777C13.2563 18.1507 13.3426 17.8296 13.5063 17.5465C13.6699 17.2634 13.9051 17.0283 14.1883 16.8648L14.5892 16.6318C14.8726 16.4681 15.1942 16.3819 15.5215 16.3819C15.8488 16.3819 16.1703 16.4681 16.4538 16.6318L16.5936 16.7063C17.0215 16.9532 17.5298 17.0201 18.007 16.8925C18.4841 16.7649 18.8912 16.4532 19.1388 16.0258L19.3439 15.6622C19.5907 15.2343 19.6576 14.726 19.53 14.2488C19.4024 13.7716 19.0907 13.3646 18.6633 13.117L18.5234 13.0424C18.2389 12.8782 18.0028 12.6416 17.8391 12.3567C17.6754 12.0719 17.5899 11.7488 17.5912 11.4202V10.9541C17.5899 10.6255 17.6754 10.3025 17.8391 10.0176C18.0028 9.73274 18.2389 9.49619 18.5234 9.33191L18.6633 9.24801C19.0907 9.00044 19.4024 8.59338 19.53 8.1162C19.6576 7.63902 19.5907 7.13071 19.3439 6.70285L19.1388 6.34858C18.8912 5.92116 18.4841 5.60943 18.007 5.48184C17.5298 5.35424 17.0215 5.4212 16.5936 5.66801L16.4538 5.74259C16.1703 5.90624 15.8488 5.9924 15.5215 5.9924C15.1942 5.9924 14.8726 5.90624 14.5892 5.74259L14.1883 5.50952C13.9051 5.34603 13.6699 5.11095 13.5063 4.82786C13.3426 4.54477 13.2563 4.22363 13.256 3.89665V3.72884C13.256 3.23432 13.0596 2.76006 12.7099 2.41038C12.3602 2.0607 11.8859 1.86426 11.3914 1.86426Z"
          strokeWidth="1.86458"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.1875 13.9844C12.7322 13.9844 13.9844 12.7322 13.9844 11.1875C13.9844 9.64283 12.7322 8.39062 11.1875 8.39062C9.64283 8.39062 8.39062 9.64283 8.39062 11.1875C8.39062 12.7322 9.64283 13.9844 11.1875 13.9844Z"
          strokeWidth="1.86458"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
]

export function PrivacyPolicyContent() {
  const [activeSection, setActiveSection] = useState<SectionId>('introduction')
  const scrollContainerRef = useRef<HTMLDivElement>(null)

  function scrollTo(id: SectionId) {
    const container = scrollContainerRef.current
    const el = document.getElementById(id)
    if (!container || !el) return

    const containerRect = container.getBoundingClientRect()
    const elRect = el.getBoundingClientRect()
    const scrollTarget = container.scrollTop + (elRect.top - containerRect.top) - 8
    container.scrollTo({ top: Math.max(0, scrollTarget), behavior: 'smooth' })
  }

  useEffect(() => {
    const container = scrollContainerRef.current
    if (!container) return

    const markerOffset = 32

    const getActiveSection = (): SectionId => {
      const rootRect = container.getBoundingClientRect()
      const marker = rootRect.top + markerOffset
      const atBottom =
        container.scrollTop + container.clientHeight >= container.scrollHeight - 2

      if (atBottom) {
        return sections[sections.length - 1]?.id ?? 'introduction'
      }

      let activeId: SectionId = 'introduction'

      for (const { id } of sections) {
        const el = document.getElementById(id)
        if (!el) continue
        if (el.getBoundingClientRect().top <= marker) {
          activeId = id
        }
      }

      return activeId
    }

    const onScroll = () => {
      const next = getActiveSection()
      setActiveSection((prev) => (prev === next ? prev : next))
    }

    onScroll()
    container.addEventListener('scroll', onScroll, { passive: true })

    return () => container.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <section className="bg-[#F5F5F5] px-4 py-12 sm:px-10 lg:px-[80px] lg:py-16">
      <div className="mx-auto flex max-w-[1280px] gap-8 lg:gap-12">
        <aside className="hidden w-[260px] shrink-0 self-start sticky top-8 lg:block">
          <div className="rounded-lg border border-neutral-200 bg-white p-6 shadow-sm">
            <h2 className="font-bebas-neue mb-5 text-sm uppercase tracking-[1.5px] text-[#1a1a1a]">
              QUICK NAVIGATION
            </h2>
            <nav aria-label="Privacy policy sections">
              <ul className="space-y-2">
                {sections.map(({ id, label, Icon }) => {
                  const isActive = activeSection === id
                  return (
                    <li key={id}>
                      <button
                        onClick={() => scrollTo(id)}
                        className={`flex w-full items-center gap-3 rounded-md px-4 py-2.5 text-left transition-colors ${
                          isActive
                            ? 'bg-[#E00000] text-white'
                            : 'text-[#4A5565] hover:bg-neutral-100'
                        }`}
                        aria-current={isActive ? 'true' : undefined}
                      >
                        <span className="flex h-7 w-7 shrink-0 items-center justify-center">
                          <Icon
                            className={`h-4 w-4 ${isActive ? 'stroke-white' : 'stroke-[#E00000]'}`}
                          />
                        </span>
                        <span className="font-bebas-neue text-sm uppercase tracking-[1px]">
                          {label}
                        </span>
                      </button>
                    </li>
                  )
                })}
              </ul>
            </nav>
          </div>
        </aside>

        <div className="min-w-0 flex-1 self-start sticky top-8">
          <div
            ref={scrollContainerRef}
            className="max-h-[calc(100vh-4rem)] overflow-y-auto rounded-lg border border-neutral-200 bg-white p-8 shadow-sm"
          >
            <div id="introduction">
              <div className="mb-6 flex items-center gap-3">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center">
                  <Image src="/images/ourBlog.svg" alt="" width={20} height={20} aria-hidden />
                </span>
                <h2 className="font-bebas-neue text-2xl font-normal uppercase tracking-wide text-[#1a1a1a]">
                  INTRODUCTION
                </h2>
              </div>
              <div className="font-poppins space-y-4 text-sm leading-relaxed text-neutral-700">
                <p>
                  Welcome to Gallium Filters. This Privacy Policy explains how we collect, use,
                  disclose, and safeguard your information when you visit our website and use our
                  services.
                </p>
                <p>
                  By accessing or using our platform, you agree to the collection and use of
                  information in accordance with this policy. We are committed to protecting your
                  privacy and ensuring your personal information is handled responsibly.
                </p>
              </div>
            </div>

            <div id="data-collection" className="mt-10 border-t border-neutral-100 pt-10">
              <div className="mb-6 flex items-center gap-3">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center">
                  {React.createElement(sections[1]!.Icon, {
                    className: 'h-5 w-5 stroke-[#E00000]',
                  })}
                </span>
                <h2 className="font-bebas-neue text-2xl font-normal uppercase tracking-wide text-[#1a1a1a]">
                  DATA COLLECTION
                </h2>
              </div>
              <div className="font-poppins space-y-4 text-sm leading-relaxed text-neutral-700">
                <p>We collect information you provide directly to us, such as when you:</p>
                <ul className="ml-4 list-disc space-y-1 pl-2 font-inter">
                  <li>Create an account or profile</li>
                  <li>Submit product enquiries or place orders</li>
                  <li>Contact us for support or inquiries</li>
                  <li>Subscribe to our newsletters or updates</li>
                </ul>
                <p>
                  The types of information we may collect include your name, email address, company
                  name, phone number, and any other information you choose to provide.
                </p>
              </div>
              <div className="mt-6 border-t border-neutral-100 pt-6">
                <p className="font-poppins text-sm leading-relaxed text-neutral-700">
                  We also automatically collect certain technical information when you interact with
                  our website, including IP address, browser type, operating system, referring URLs,
                  and pages visited. This data helps us improve our platform and deliver a better
                  user experience.
                </p>
              </div>
            </div>

            <div id="use-of-data" className="mt-10 border-t border-neutral-100 pt-10">
              <div className="mb-6 flex items-center gap-3">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center">
                  {React.createElement(sections[2]!.Icon, {
                    className: 'h-5 w-5 stroke-[#E00000]',
                  })}
                </span>
                <h2 className="font-bebas-neue text-2xl font-normal uppercase tracking-wide text-[#1a1a1a]">
                  USE OF DATA
                </h2>
              </div>
              <div className="font-poppins space-y-4 text-sm leading-relaxed text-neutral-700">
                <p>We use the information we collect to:</p>
                <ul className="ml-4 list-disc space-y-1 pl-2">
                  <li>Provide, maintain, and improve our products and services</li>
                  <li>Process enquiries and manage your account</li>
                  <li>Send you important updates about your orders and account</li>
                  <li>Respond to your comments, questions, and support requests</li>
                  <li>Analyse usage patterns to enhance user experience</li>
                  <li>Comply with legal obligations and protect our rights</li>
                </ul>
              </div>
              <div className="mt-6 border-t border-neutral-100 pt-6">
                <p className="font-poppins text-sm leading-relaxed text-neutral-700">
                  We do not sell, trade, or otherwise transfer your personal information to outside
                  parties except as described in this policy or with your explicit consent. We may
                  share data with trusted service providers who assist us in operating our website
                  and conducting our business, provided they agree to keep your information
                  confidential.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
